import { ChangeDetectionStrategy, Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppState } from '@app/reducers/interfaces';
import { Store } from '@ngrx/store';
import { CardComponent } from '@sb/ui/card';
import { take } from 'rxjs';

import { selectAuthUserId } from '../../../../../reducers/auth/auth.selectors';
import { EnhancedAbsenceModel } from '../../../../../reducers/orm/absence/absence.model';
import { AbsenceRowComponent } from './absence-row.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'absence-list',
  imports: [AbsenceRowComponent, CardComponent],
  templateUrl: './absence-list.component.html',
})
export class AbsenceListComponent implements OnInit {
  private store = inject<Store<AppState>>(Store);
  private destroyRef = inject(DestroyRef);

  @Input()
  absences: EnhancedAbsenceModel[] = [];

  authUserId: string;

  ngOnInit() {
    this.setAuthUserId();
  }

  private setAuthUserId() {
    void this.store
      .select(selectAuthUserId)
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe((authUserId) => {
        this.authUserId = authUserId;
      });
  }
}
